/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-return-assign */
import { openModal } from "action/modal/openModal";
import { AMP_SELECT_VEHICLE_LOCATIONS } from "analytics/amplitude/amplitudeEvents";
import classNames from "classnames";
import GarageDropdown from "component/garage-dropdown/garage-dropdown.component";
import { RootState } from "interfaces/generics.type";
import { ShoppingCart, TextAlignJustify, User } from "lucide-react";
import Image from "next/legacy/image";
import Link from "next/link";
import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { b2bUrl } from "util/url/static-urls";
import { logout } from "../../action/auth/logout";
import Popover from "../../component/design-system/popover/Popover";
import HeaderCartIcon from "./HeaderCartIcon";
import MobileAccountDropdown from "./MobileAccountDropdown";
import styles from "./mobile-header.module.scss";

function MobileHeader(props: any) {
  const {
    openSlideMenu, onClickLogin, handleShoppingCartClick,
  } = props;

  const auth = useSelector((state: RootState) => state.authenticationState);
  const { businessCustomer } = auth;
  const isLoading = auth.refreshStatus !== "complete";
  const dispatch = useDispatch();

  function onSignOutClick() {
    dispatch(logout());
  }

  function handleAddVehicleClick() {
    dispatch(openModal("vehicleSelector", { forceTrigger: true, addNewVehicle: true }));
  }

  return (
    <nav className={`navbar pa-navbar-inverse p-b-5 ${styles.mobile_navbar}`}>

      <div className={styles.navbar_fluid_container}>
        <div className={`pa-navbar-header d-flex ${styles.pa_navbar_header}`}>

          <button
            type="button"
            aria-label="side-menu"
            data-testid="btn-slide-menu"
            className={classNames("d-flex align-items-center", styles.btn_slide_menu)}
            onClick={openSlideMenu}
          >
            {/* inline svg are faster */}

            <TextAlignJustify color="#fff" />
          </button>

          <div>
            <Link
              href={businessCustomer ? b2bUrl : "/"}
              prefetch={false}
              title="Welcome to PartsAvatar: Your Car Parts Hub"
            >

              <Image
                unoptimized
                width={200}
                height={70}
                src={`${process.env.NEXT_PUBLIC_ROOT_URL}/images/common/header-logo_16051144.png`}
                alt="Upgrade Your Ride with PartsAvatar's Auto Parts and Tools"
                title="Upgrade Your Ride with PartsAvatar's Auto Parts and Tools"
              />

            </Link>
          </div>
        </div>

        <ul className={`nav pa-navbar-top-links pull-right ${styles.pa_navbar_top_links}`}>

          <li className={styles.vehicle_list}>
            <GarageDropdown
              dropdownId="dropdown-search-garage"
              aria-label="dropdown-search-garage"
              toggleButtonClassName={`${styles.mobile_vehicle_dropdown_button} btn-sm btn-block`}
              buttonText=""
              onAddVehicleClick={handleAddVehicleClick}
              showVehicleCount
              showDropdownArrow
              loc={AMP_SELECT_VEHICLE_LOCATIONS.HEADER}
            />
          </li>

          {!auth.loggedIn && (
            <li onClick={onClickLogin}>
              <User data-testid="header-user-icon" />
            </li>
          )}
          {!isLoading && auth.loggedIn && (
            <li>

              <Popover
                placement="bottom-end"
                overlay={(
                  <MobileAccountDropdown
                    firstName={auth.firstName}
                    onSignOut={onSignOutClick}
                  />
                )}
              >
                <User />
              </Popover>
            </li>
          )}

          <li className={`${styles.list_item} `} style={{ width: "auto" }}>
            <HeaderCartIcon>
              <span title="Items Ready for Checkout in Your Cart" className="p-0" onClick={handleShoppingCartClick}>
                <ShoppingCart data-testid="header-cart-icon" />

                <div />
              </span>
            </HeaderCartIcon>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default memo(MobileHeader);
